<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7YQFI9/tc-custom/9781939904119.jpg?1719603450047" alt="This image is the cover for the book Junglee Girl"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Junglee Girl
      </h1>
      <p class="bookDescription body article font2">
        <p>Junglee (stemming from the Sanskrit root "jungle") is used in India to label the wild, the uncivilized, the untamed. Used most commonly as condemnation or censure, it aims to break the spirit of women yearning for personal power. The female protagonists in these eleven stories recklessly pursue their sensual paths through a complex social world that seeks to shut them out. With wily irreverence and a willful rawness, Kamani pulls back the veil of convention, inch by inch, and draws the reader into the disquieting truth of women's lives, charting territory both intimate and bizarre.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ginu Kamani
      </h2>
      
      <p class="authorDescription body article">Ginu Kamani was born in Bombay, India and moved to the U.S. at age 14. She graduated with an M.A. in English and Creative Writing from the University of Colorado, Boulder. Kamani returned to Bombay for three years to work in film production before returning to the U.S., where she spent time as a professor at Mills College and continued to work on writing and film projects. Two of her short stories from Junglee Girl and several of her poems were published under her full name, Gaurangi Kamani, in the anthology <i>Our Feet Walk the Sky: Women of the South Asian Diaspora</i>. Kamani currently uses her knowledge of herbs, oils, and gardening in her work with woodsmen-artist-farmers in a volcanic rainforest environment in Dominica.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      aunt lute books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37b950c5